import { ApiError } from '@/lib/api-client';

/** Human-readable message for any thrown value. */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.problem.detail || error.problem.title;
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}

/** Flattened field errors (first message per field) for form display. */
export function getFieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) return {};
  return Object.fromEntries(
    Object.entries(error.fieldErrors).map(([field, messages]) => [field, messages[0] ?? '']),
  );
}
